import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { NL } from "../i18n/nl";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pm_lang") || "en");

  useEffect(() => {
    localStorage.setItem("pm_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const tr = (text) => {
      if (lang !== "nl" || typeof text !== "string") return text;
      return NL[text] ?? text;
    };
    return { lang, setLang, tr, trList: (list = []) => list.map(tr) };
  }, [lang]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
